export default __webpack_public_path__ + "img/pk-467560d5.png";